module.exports = __webpack_public_path__ + "static/media/icons8-instagram-144.3992c0d6.png";